export const isDev = (() => {
  return (__DEV__ || process.env.APP_ENV === 'development' || process.env.APP_ENV === 'local'); // eslint-disable-line
})();
